<template>
<div class="frm">
<div id="mail">

  <!-- 회의정보 -->
  <div v-show="this.userId" id="mail_content2"  class="mainArticle">

    <div class="heads">Smart <span class="banner">Meeting</span> </div>
    <div style="display:none;">회의참석 안내 및 참석여부 회신 요청</div>

    <div class="heads_sub">아래와 같이 회의가 예정되어 있으니, 참석부탁드립니다.</div>
    <br>
    <br>
    <br>

    <div class="title" id="title"></div>
    <div class="met_date" id="met_date"></div>
    <div class="met_loc" id="met_loc"></div>
    
    <br>

  </div>

  <!-- 참석여부 -->

  <div v-show="this.userId" class="mainArticle">
    <table >
        <colgroup style="width:500px"><col width="25%"><col width="75%"></colgroup>
        <tbody>
            <tr>
                <th>참석</th>
                <td>
                    <label><input type='radio' id='attend_typ_1' name='attend_typ' value='1' @change="fn_change" > 대면참석 </label>
                    <label><input type='radio' id='attend_typ_2' name='attend_typ' value='2' @change="fn_change" > 화상참석 </label>
                </td>
            </tr>
            <tr>
                <th>불참</th>
                <td>
                  <div>
                      <label><input type='radio' id='absent_typ_1' name='absent_typ' value='1' @change="fn_change" > 출장</label>&nbsp;&nbsp;
                      <label><input type='radio' id='absent_typ_2' name='absent_typ' value='2' @change="fn_change" > 근태</label>&nbsp;&nbsp;
                      <label><input type='radio' id='absent_typ_9' name='absent_typ' value='9' @change="fn_change" > 기타</label>
                      <!-- <label><input type='radio' id='absent_typ_3' name='absent_typ' value='3' @change="fn_change" > 대리</label> -->
                  </div>
                  <div style="margin-top: 25px;">
                    불참사유 : <br> 
                    <label for='absent_desc' ><input type='text' v-model="absent_desc" id='absent_desc' class='absent_desc' name='absent_desc'  > </label>
                  </div>
                  <div style="margin-top: 20px;">
                    대리참석자 지정 :  <br>
                      <label for='deputy_id' ><input type='text' v-model="deputy_id" id='deputy_id' class='deputy_id' name='deputy_id'  > </label>
                    
                  </div>
                </td>
            </tr>
        </tbody>
    </table>

    <div id='replyBtn' class='btnArea' style="text-align: center; margin-top: 30px;">
        <div class="cm-btn-controls cm-btn-long-controls">
            <button id='btnReplyReq' class="btn btn-primary" @click="fn_ReplyReq();" style="margin-right:30px; font-size:22px;">참석여부 저장</button>
        </div>
    </div>
    
  </div>







  <article class='cmpltArticle' style='display:none;'>
      <span style='font-size: 32px;text-align: center;padding: 20px;margin: auto;' >회의 참석에 대한 회신을 주셔서 감사합니다.</span>
  </article>

</div>
</div>
</template>




<style scoped>

    
  /* 공통 */
  .frm{
    display: flex;
    justify-content: center;
  }
  #mail{
    text-align: left;
    padding: 10px;
    max-width:960px; 
  }

  #mail_content2{
    background-color: #e6f2ff;
    padding: 20px;
  }

  .heads{
    color: #003366;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-size: 43px;
    font-weight: bold;
    padding: 3px;
  }
  .banner{
    font-size: 30px;
    font-weight: bold;
    padding: 3px;
  }

  .heads_sub{
    color: #000;
    font-size: 21px;
    font-weight: bold;
    padding: 3px;
  }

  .title{
    color: #000;
    font-size: 24px;
    font-weight: bold;
    padding: 3px;
  }
  .met_loc{
    color: #0066cc;
    font-size: 20px;
    font-weight: bold;
    padding: 3px;
  }
  .met_date{
    color: #0066cc;
    font-size: 20px;
    font-weight: bold;
    padding: 3px;
  }
  .met_date::v-deep(.zone){
    color: #666;
    font-size: 13px;
    padding: 3px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .reg_info{
    color: #666;
    font-size: 17px;
  }


  #mail::v-deep(.divall){
    width: 700px;
    font-size: 13px;
    margin-top: 40px;
  }
  #mail::v-deep(table) {
    margin: 10px 0px;
      border: solid 1px #aaa;
      border-collapse: collapse;            
  }

  #mail::v-deep(tr) {
    height: 50px;
  }
  #mail::v-deep(button) {
      background-color: dodgerblue;
      color: white;
      border: 0px;
      padding: 10px 30px;
      font-weight: bold;
  }
  #mail::v-deep(.divbtm) {
      text-align: center;
      margin-top: 30px;
  }
  #mail::v-deep(.divcmt) {
        width: 600px;
        height: 100px;
        border: solid 2px #555;
        border-radius: 10px;
  }
  table::v-deep(label) {
      margin-right: 10px;
  }
  table::v-deep(div) {
      margin-top: 2px;
  }



/* 데스크탑 
@media only screen and (min-width:1200px){

  #mail::v-deep(th) {
      border: solid 1px #aaa!important;
      color: #000;
      padding: 5px 10px;
      background-color: #bbb;
      font-size: 17px;
      font-weight: bold;
  }
  #mail::v-deep(td) {
      border: solid 1px #ccc!important;
      padding: 10px 10px;
      text-align: start;
      color: #000;
      font-size: 17px;
  }


  .absent_desc {
    height:24px; 
    width: 500px;
    border: 1px solid #bbb;
  }
  .deputy_id{
    height:24px; 
    width: 200px;
    border: 1px solid #bbb;
  }

  table::v-deep(input) {
      height: 13px;
  } 
}
*/





/* 스마트폰 
@media only screen and (max-width:390px){

}
*/

  #mail::v-deep(th) {
      border: solid 1px #aaa!important;
      color: #000;
      padding: 15px;
      background-color: #bbb;
      font-size: 22px;
      font-weight: bold;
  }
  #mail::v-deep(td) {
      border: solid 1px #ccc!important;
      padding: 15px;
      text-align: start;
      color: #000;
      font-size: 22px;
  }


  .absent_desc {
    height:40px; 
    width: 500px;
    border: 1px solid #bbb;
  }
  .deputy_id{
    height:40px; 
    width: 200px;
    border: 1px solid #bbb;
  }

  table::v-deep(input) {
      height: 25px;
      width: 25px;
      bottom: -5px;
      position: relative;
    }






</style>



<script>
import { defineComponent, ref ,reactive} from 'vue'
import {ElMessageBox, ElIcon} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
const {cipher,decipher} = require('/public/js/crypto.js')

 
function Mobile() {return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);}



export default {
  props: {
		_PARAM: {
			type: String,
			default: ''
		},
  },
	data(){
		return{
      PARAM : this._PARAM,
      midx : '' ,
      idx : '' ,
      mail_title : '' ,
      mail_content : '' ,
      mail_content2 : '' ,
      deputy_nm : '' ,
      deputy_id : '' ,
      absent_desc : '' ,
      replyform : {attend_yn : '' , attend_typ : '' , deputy_id : '', deputy_nm : '' , absent_typ : '' , absent_desc : '' ,},
      selectCheckbox : '',

      userId: '', //사번
      EP_SABUN:'', //sso사번
		}
	},
	created(){

    // let obj = JSON.parse(decodeURIComponent(escape(window.atob(this.PARAM))));
    let obj = JSON.parse(decipher(decodeURIComponent(this.PARAM)));

    this.midx = obj.midx;
    this.idx = obj.idx;


    //1.회의정보 가져와서 본문 뿌리기
    this.doSearchEmpMeet(this.midx, this.idx)

	},


  // 웹소켓관련
  mounted(){


    fetch('https://api.ipify.org?format=json')
    .then(x => x.json())
    .then(({ ip }) => {
        console.log(`JSON.stringify(ip) - ${JSON.stringify(ip)}`) 
    })
    .catch((e) => {
      console.log(`fetch error - ${e}`)
    });

    // alert(`Mobile - ${Mobile()}`)

  },

	computed: {

	},


	methods:{




    //직원회의정보 가져오기
		doSearchEmpMeet (_midx, _idx) {

      this.$store.commit('showLoading')

			this.axios ({
				method: 'POST',
				url: MYDATA_CONFIG.API_DOMAIN + '/api/v1/attendee/nosession/list2',
				headers: {
					'X-Requested-With': 'xmlhttprequest'
					// ,'Rest-With': 'restrequest'
				},
				data: {
					params:{
            midx : _midx,
            idx : _idx, //idx대신 userId로 조회
						sqlId: 'AttendMapper.selectAttendeeInfo_nosession3',
					}
				}
			}).then ((response) => {
        // 공통응답처리
        if(!this.$checkAjaxResult(response)) {
          return
        }

				//성공응답
				try {

				  this.$store.commit('hideLoading')


          if(response.data.result == null || !response.data.result || response.data.result.length < 1){
            document.querySelectorAll(".mainArticle").forEach((item) => { item.style.display = 'none'})
            document.querySelector(".cmpltArticle").style.display = 'grid';
            document.querySelector(".cmpltArticle span").innerHTML = "해당 회의는 삭제되었습니다." ;
            return false;
          }
          else if( `${response.data.result[0].prcCd}` == '03' ){
            document.querySelectorAll(".mainArticle").forEach((item) => { item.style.display = 'none'})
            document.querySelector(".cmpltArticle").style.display = 'grid';
            document.querySelector(".cmpltArticle span").innerHTML = "해당 회의는 종료되었습니다." ;
            return false;
          } else if( `${response.data.result[0].attendYn}` != 'NA' ){
            /* 
            // 중복작성 허용
            document.querySelectorAll(".mainArticle").forEach((item) => { item.style.display = 'none'})
            document.querySelector(".cmpltArticle").style.display = 'grid';
            document.querySelector(".cmpltArticle span").innerHTML = "이미 회신처리된 참석정보입니다." ;
            return false;
            */
          } else if( `${response.data.result[0].userYn}` == 'X' ){
            document.querySelectorAll(".mainArticle").forEach((item) => { item.style.display = 'none'})
            document.querySelector(".cmpltArticle").style.display = 'grid';
            document.querySelector(".cmpltArticle span").innerHTML = "귀하는 수신된 참석자메일의 대상자가 아닙니다." ;
            return false;
          }

          this.userId = response.data.result[0].userYn //참석자사번

          this.mail_title = response.data.result[0].mailTitle;
          this.mail_content = response.data.result[0].mailContent.replace(/\n/g,'<br>') ;

          // 회의정보 처리
          // document.querySelector('#mail_content2').innerHTML = this.mail_content2 + "<br><br><br>";
          try {
            document.querySelector('#title').innerHTML = `${response.data.result[0].name}`
            document.querySelector('#met_date').innerHTML = `${response.data.result[0].metDd} (${response.data.result[0].wday})     ${response.data.result[0].stTm.substr(0,2)}:${response.data.result[0].stTm.substr(2)} ~ ${response.data.result[0].edTm.substr(0,2)}:${response.data.result[0].edTm.substr(2)} 
            <div class="zone" >(Asia/Seoul GMT +09:00)</div>`
            document.querySelector('#met_loc').innerHTML = `${response.data.result[0].roomName}`
          } catch{()=>{}}

				} catch{()=>{}}

			}).catch(error => {
				this.$showErrorMsg(error)
			}).finally(()=>{
				this.$store.commit('hideLoading')
			})

		},




    fn_ReplyReq(){
        // const basicView= document.querySelector('#basicBtn');
        let attend_yn= '' // 참석여부
        const attend_typ= document.querySelector("input[name='attend_typ']:checked") ? document.querySelector("input[name='attend_typ']:checked").value : '' // 참석코드
        const absent_typ= document.querySelector("input[name='absent_typ']:checked")? document.querySelector("input[name='absent_typ']:checked").value : '' // 불참코드
        const absent_desc= document.querySelector("#absent_desc")? document.querySelector("#absent_desc").value : '' //불참사유

        //참석
        if(attend_typ == '1' || attend_typ == '2' ){
          attend_yn = 'Y'
        }
        //불참
        else if(absent_typ == '1' || absent_typ == '2' || absent_typ == '9'){
          attend_yn = 'N'
          this.replyform.deputy_id = this.deputy_id;

          if(absent_desc) {
            this.replyform.absent_desc = absent_desc;
          }
          else {
            alert('불참사유를 입력하세요.');
            return false;
          }
        }

        if(!attend_yn){
          alert('참석여부를 입력하세요.');
          return false;
        }


        // 응답처리
        this.replyform.attend_yn = attend_yn;
        this.replyform.attend_typ = attend_typ;
        this.replyform.absent_typ = absent_typ;
        this.doReply(this.replyform);

   },

    doReply(objReply){
      // single체크
      // let singleid = prompt('SingleID를 입력하세요.')
      // if(singleid){
      //   objReply.singleid = singleid;
      // } 
      // else{
      //   return false
      // }


      if(!this.$confirmMsg('참석회신 처리하시겠습니까?'))
				return false

      objReply.midx = this.midx;
      objReply.idx = this.idx;
			this.$store.commit('showLoading')

			this.axios ({
				method: 'POST',
				url: MYDATA_CONFIG.API_DOMAIN + '/api/v1/attendee/nosession/reply2',
				headers: {
					'X-Requested-With': 'xmlhttprequest'
				},
				data: {
					params: Object.assign({},objReply)
				}
			}).then ((response) => {
        // 공통응답처리
				if(!this.$checkAjaxResult(response)) {
					return
				}

				if(response.data.successYn == 'N') {
					// this.$showMsg(response.data.message)
					this.$showMsg('해당회의의 참석자가 아닙니다.')
					this.$store.commit('hideLoading')
					return
				}

				//성공응답
				try {
					this.$showMsg('참석여부 회신처리되었습니다')
          this.$store.commit('hideLoading')
          document.querySelectorAll(".mainArticle").forEach((item) => { item.style.display = 'none'})
          document.querySelector(".cmpltArticle").style.display = 'grid'; // display: grid;height: 600px;
          window.open('','_self').close();
          // window.document.close()

				} catch (error) {
					this.$showErrorMsg(error)
          this.$store.commit('hideLoading')
				}

			}).catch(error => {
				this.$showErrorMsg(error)
          this.$store.commit('hideLoading')
			})
    },


    // 라디오 토글변경
    fn_change(e){
        //1.참석라디오
        if(e.target.name == 'attend_typ'){
          try {
            document.querySelector("input[name='absent_typ']:checked").checked = false 
          } catch {()=>{}}

          document.querySelector('#absent_desc').disabled = true  
          document.querySelector('#deputy_id').disabled = true  
          this.absent_desc = ''
          this.deputy_nm = ''
          this.deputy_id = ''

        }
        //2.불참라디오
        else if(e.target.name == 'absent_typ'){
          try {
            document.querySelector("input[name='attend_typ']:checked").checked = false 
          } catch  {()=>{}}
          //대리참석
          document.querySelector('#absent_desc').disabled = false
          document.querySelector('#deputy_id').disabled = false

        }

    },


		


	



	}//methods

}
</script>

